import React, { lazy, Suspense } from 'react'
import { FaSpinner } from "react-icons/fa";

const Loginstatus = lazy(() =>
  import("../../components/Login/Login")
);

const Login = () => {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-screen">
          <FaSpinner className="animate-spin text-red-500 text-2xl" />
        </div>
      }
    >
      <Loginstatus />
    </Suspense>
  )
}

export default Login